import Label from '../Overlays/Label';
import Guid from '../utils/Guid';
var Overlayerbase = /** @class */ (function () {
    function Overlayerbase(overlayeroption) {
        this.uuid = new Guid().uuid;
        this.label = overlayeroption.label !== undefined ? overlayeroption.label : new Label({ visible: false });
        this.attributes = overlayeroption.attributes === undefined ? {} : overlayeroption.attributes;
        this.type = "element";
        this.renderer = overlayeroption.renderer;
        this.elevationInfo = overlayeroption.elevationInfo;
        this.symbol = overlayeroption.symbol;
    }
    return Overlayerbase;
}());
export default Overlayerbase;
